import React from 'react';
import './Experience.css';
const Experience = () => {
    return (
        <section id="experience" className="container">
            <div className="section-header">
                <h2 className="section-title">Work Experience</h2>
                <p className="section-subtitle">My professional journey in backend development</p>
            </div>

            <div className="experience-timeline">
                <div className="experience-item">
                    <div className="experience-content">
                        <span className="experience-date">Nov 2022 – Present</span>
                        <h3 className="experience-title">Backend / Python Developer (Freelancer)</h3>
                        <div className="experience-company">Khamsat</div>
                        <div className="experience-description">
                            <p>Leading backend projects and mentoring junior developers.</p>
                            <ul>
                                <li>Managed 55 clients across UAE, Saudi Arabia, and other countries, delivering backend systems for school events and business applications.</li>
                                <li>Translated client needs into technical solutions aligned with industry standards.</li>
                                <li>Developed robust backend systems using Python (Django) to ensure performance and scalability.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="experience-item">
                    <div className="experience-content">
                        <span className="experience-date">May 2025 – Mar 2026</span>
                        <h3 className="experience-title">Backend Developer / Team Leader</h3>
                        <div className="experience-company">Jood Elevators COMPANY (Riyadh, KSA)</div>
                        <div className="experience-description">
                            <p>Led backend development for enterprise resource planning systems.</p>
                            <ul>
                                <li>Developed and managed a full ERP System using Python (Django), covering clients, maintenance, and inventories sections.</li>
                                <li>Led the backend team, ensuring code quality and timely delivery of features.</li>
                                <li>Provided ongoing support and resolved technical issues across the system.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="experience-item">
                    <div className="experience-content">
                        <span className="experience-date">Oct 2023 – June 2024</span>
                        <h3 className="experience-title">Backend Developer (Part Time)</h3>
                        <div className="experience-company">ATLAS Elevators COMPANY (Dubai, UAE)</div>
                        <div className="experience-description">
                            <p>Worked on various web applications and internal tools.</p>
                            <ul>
                                <li>Architected and developed backend for a custom CRM system using Django.</li>
                                <li>Led a cross-functional team, ensuring alignment between backend, frontend, and deployment.</li>
                                <li>Built and maintained microservices to support scalable features.</li>
                                <li>Managed deployments and cloud infrastructure on AWS and PythonAnywhere.</li>
                                <li>Facilitated smooth API integration with frontend components.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="experience-item">
                    <div className="experience-content">
                        <span className="experience-date">Sep 2022 – Sep 2023</span>
                        <h3 className="experience-title">Backend Developer</h3>
                        <div className="experience-company">SARC-Syrian Arab Red Crescent</div>
                        <div className="experience-description">
                            <p>Supported development of internal systems and client projects.</p>
                            <ul>
                                <li>Built CRUD applications with Django ORM.</li>
                                <li>Wrote unit tests to ensure code quality.</li>
                                <li>Maintained GitHub repositories and CI/CD pipelines.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Experience;